import type { CandidateEditableProfileDto } from "@artha/api-contracts";
import type { ResumeReviewForm } from "./personalization.types";

export const EMPTY_REVIEW_FORM: ResumeReviewForm = {
  name: "",
  email: "",
  phone: "",
  titles: "",
  skills: "",
  keywords: "",
  experienceYears: "",
  educationLevel: "",
  educationField: "",
  city: "",
  state: "",
  country: "",
  workMode: "",
};

export const toReviewForm = (
  profile: CandidateEditableProfileDto,
): ResumeReviewForm => ({
  name: profile.name,
  email: profile.email,
  phone: profile.phone,
  titles: profile.titles.join(", "),
  skills: profile.skills.join(", "),
  keywords: profile.keywords.join(", "),
  experienceYears:
    typeof profile.experienceYears === "number"
      ? String(Math.round(profile.experienceYears))
      : "",
  educationLevel: profile.education?.[0]?.level || "",
  educationField: profile.education?.[0]?.field || "",
  city: profile.location?.city || "",
  state: profile.location?.state || "",
  country: profile.location?.country || "",
  workMode: profile.workMode || "",
});

const parseList = (value: string) => {
  const seen = new Set<string>();
  return value.split(",").reduce<string[]>((items, entry) => {
    const clean = entry.trim();
    const key = clean.toLowerCase();
    if (clean && !seen.has(key)) {
      seen.add(key);
      items.push(clean);
    }
    return items;
  }, []);
};

export const toEditableProfile = (
  form: ResumeReviewForm,
): CandidateEditableProfileDto => ({
  name: form.name.trim(),
  email: form.email.trim().toLowerCase(),
  phone: form.phone.trim(),
  titles: parseList(form.titles),
  skills: parseList(form.skills),
  keywords: parseList(form.keywords),
  ...(form.experienceYears.trim()
    ? { experienceYears: Math.round(Number(form.experienceYears)) }
    : {}),
  ...(form.educationLevel.trim() || form.educationField.trim()
    ? {
        education: [
          {
            ...(form.educationLevel.trim()
              ? { level: form.educationLevel.trim() }
              : {}),
            ...(form.educationField.trim()
              ? { field: form.educationField.trim() }
              : {}),
          },
        ],
      }
    : {}),
  ...(form.city.trim() || form.state.trim() || form.country.trim()
    ? {
        location: {
          ...(form.city.trim() ? { city: form.city.trim() } : {}),
          ...(form.state.trim() ? { state: form.state.trim() } : {}),
          ...(form.country.trim() ? { country: form.country.trim() } : {}),
        },
      }
    : {}),
  ...(form.workMode.trim() ? { workMode: form.workMode.trim() } : {}),
});

export const PERSONALIZATION_FIELD_CLASS_NAME =
  "h-11 w-full rounded-[10px] border border-black bg-white px-3 text-sm text-[#101828] outline-none focus:ring-2 focus:ring-[#F8D96B]";
